module.exports = __webpack_public_path__ + "img/2842b64.jpg";